import { atom } from "jotai";

// Loading state atoms
export const isLoadingTasksAtom = atom(false);
export const isLoadingPreferencesAtom = atom(false);
export const isLoadingUserDataAtom = atom(false);

// Error state atoms
export const taskErrorAtom = atom(null);
export const userErrorAtom = atom(null);
export const globalErrorAtom = atom(null);

// Combined loading state
export const isLoadingAtom = atom((get) => {
  return (
    get(isLoadingTasksAtom) ||
    get(isLoadingPreferencesAtom) ||
    get(isLoadingUserDataAtom)
  );
});
